import { getStoreBuilder,BareActionContext } from "vuex-typex";
import { ProductListState, RootState ,PorterItemsState} from "Store/types";
import { State } from "vuex-class";
import { FilterItem } from "Models/FacetFilter/FilterItem";
import { ProductListPage } from "Models/Products/ProductListPage";
import { Client, GetPorterProductListItemsViewModel, PorterItemViewModel, PorterItemsSize } from "Api/CoreApi";
import ApiProvider from "Api/ApiProvider";


const initialPorterItemsState: PorterItemsState = {
    porterItemsSelectedSizes: {}, 
    porterItemsAvailableSizes: {},
    porterItems: [] as PorterItemViewModel[], 
    porterItemsMissingSize: [] as PorterItemViewModel[]

}

const p = getStoreBuilder<RootState>().module("porterItems", initialPorterItemsState);
var loadPromise : Promise<void>;
//Getters

//Mutations
function setLoading(state:ProductListState){
    state.isLoading = true;
}
function setLoaded(state:ProductListState){
    state.isLoading = false;
}


function setPorterItemsData(state: PorterItemsState, viewModel: GetPorterProductListItemsViewModel) {
    state.porterItemsMissingSize = viewModel.porterItemsMissingSize;
    state.porterItems = viewModel.porterItems;
    state.porterItemsSelectedSizes = viewModel.porterItemsSelectedSizes;
    state.porterItemsAvailableSizes = viewModel.porterItemsAvailableSizes; 
}



//Actions
async function getPorterItems(context: BareActionContext<PorterItemsState,RootState>,params: {languageId:string, porterId:string})
{
    const client = ApiProvider.getApiClient();
    let result = await client.getPorterProductListItems(params.languageId, params.porterId);
    porterItems.commitUpdatePorterItems(result);
}

function getSizes(context: BareActionContext<PorterItemsState, RootState>,
    params: { itemNo: string, }): PorterItemsSize[] {
    return porterItems.state.porterItemsAvailableSizes[params.itemNo] != null
        ? porterItems.state.porterItemsAvailableSizes[params.itemNo]
        : [] as PorterItemsSize[]; 


}

function getSelectedSize(context: BareActionContext<PorterItemsState, RootState>,
    params: { itemNo: string, }): PorterItemsSize[]
{
    return porterItems.state.porterItemsSelectedSizes[params.itemNo] != null
        ? porterItems.state.porterItemsSelectedSizes[params.itemNo]
        : []; 
}



//State
const stateGetter = p.state();

const porterItems = {
    //State
    get state() {return stateGetter()},

    //Getters

    //Mutations
    commitUpdatePorterItems: p.commit(setPorterItemsData),

    //Actions
    dispatchGetPorterItems: p.dispatch(getPorterItems), 
    dispatchGetSizes: p.dispatch(getSizes),
    dispatchGetSelectedSizes: p.dispatch(getSelectedSize),

}
export default porterItems;